import {
    AdMonetization,
    Charts,
    CreativeExplore,
    FraudProtected,
    FraudRejected,
    FraudSuspicious,
    Reports,
    SkanReport,
    SkanSummaryReport,
    UnifiedReport,
} from '../services';

const reportsAPI = new Reports();
const chartsAPI = new Charts();
const skanReportAPI = new SkanReport();
const skanSummaryReportAPI = new SkanSummaryReport();
const fraudProtectedAPI = new FraudProtected();
const unifiedReportAPI = new UnifiedReport();
const fraudSuspiciousAPI = new FraudSuspicious();
const fraudRejectedAPI = new FraudRejected();
const adMonetizationAPI = new AdMonetization();
const creativeExploreAPI = new CreativeExplore();

export const queryTypeToAPI = {
    reports: reportsAPI,
    pivot: reportsAPI,
    crossDevice: reportsAPI,
    fraudProtected: fraudProtectedAPI,
    fraudSuspicious: fraudSuspiciousAPI,
    fraudRejected: fraudRejectedAPI,
    charts: chartsAPI,
    adMonetization: adMonetizationAPI,
    skan: skanReportAPI,
    skanSummary: skanSummaryReportAPI,
    unifiedReport: unifiedReportAPI,
    creativeExplore: creativeExploreAPI,
};
